/* eslint-disable */

export const stopAllBotsStrategyConstants = {
    STOP_ALL_STRATEGY_REQUEST: 'STOP_ALL_STRATEGY_REQUEST',
    STOP_ALL_STRATEGY_SUCCESS: 'STOP_ALL_STRATEGY_SUCCESS',
    STOP_ALL_STRATEGY_FAILURE: 'STOP_ALL_STRATEGY_FAILURE',
};
